// extracted by mini-css-extract-plugin
module.exports = {"grid":"markdown-internal-grid_grid__jaW9H"};